import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';



import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';

import RequestHeader from './RequestHeader';
import TransactionComment from './TransactionComment';

function CoverRate(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [userRight, setUserRight] = useState([]);

    const [reqSrNo, setReqSrNo] = useState(0);
    const [reqQuantity, setReqQuantity] = useState(0);


    const [reqCoverBank, setReqCoverBank] = useState("0");
    const [ddCoverBank, setDdCoverBank] = useState([]);
    const [reqCoverBankName, setReqCoverBankName] = useState("");
    const [reqCoverValue, setReqCoverValue] = useState("");
    const [reqCoverRate, setReqCoverRate] = useState("");
    const [reqCoverDeal, setReqCoverDeal] = useState("");
    const [reqCoverValDate, setReqCoverValDate] = useState(new Date());
    const [reqCoverFinal, setReqCoverFinal] = useState(1);

    const [coverListData, setCoverListData] = useState([]);

    const [reqCoverTotValue, setReqCoverTotValue] = useState(0);

    const [reqData, setReqData] = useState([]);
    const [showReject, setShowReject] = useState(false);

    const [chngQtyListData, setChngQtyListData] = useState([]);
    const [rightAprovQty, setRightAprovQty] = useState([]);

    const [showConfirmBox, setShowConfirmBox] = useState(false);

    const [remark, setRemark] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'COVERRATE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result) {
                        // setReqData(JSON.parse(result));
                        let resp = JSON.parse(result);
                        setReqData(resp);
                        setChngQtyListData(resp.req_changeqty);


                        setReqSrNo(resp.req_srno);
                        setReqQuantity(resp.req_quantity);


                        setReqCoverBank(resp.req_bank);
                        setReqCoverBankName(resp.req_banknm);

                        var d = new Date(resp.req_valuedate);
                        if (resp.req_tenure === "TOM") {
                            d.setDate(d.getDate() + 1);
                        }
                        if (resp.req_tenure === "SPOT") {
                            d.setDate(d.getDate() + 2);
                        }
                        setReqCoverValDate(d);
                        /*
                        const valueDate = new Date();
                        console.log(valueDate);
                        if (reqData.req_tenure === "CASH") {
                            setReqCoverValDate(new Date());
                        }
                        if (reqData.req_tenure === "TOM") {
                            setReqCoverValDate(valueDate.setDate(valueDate.getDate() + 1));
                            //setReqCoverValDate((resp.req_valuedate).getDate() + 1);
                        }
                        if (reqData.req_tenure === "SPOT") {
                            setReqCoverValDate((new Date()).getDate() + 2);
                        }*/

                        setReqCoverFinal(resp.req_coverfinal);
                        Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                            setDdCoverBank(JSON.parse(result));
                        });
                        Common.callApi(Common.apiCover, [sid, 'listjson', props.srno], function (result) {
                            var arr = JSON.parse(result)
                            setCoverListData(arr);
                            var tvalue = 0;
                            if (arr.length > 0) {
                                setReqCoverBank(arr[0]["bank"]);
                                setReqCoverBankName(arr[0]["banknm"]);

                                for (var i = 0; i < arr.length; ++i) {
                                    tvalue = tvalue * 1 + arr[i]["cvalue"] * 1;
                                }
                                setReqCoverTotValue((tvalue).toFixed(2));
                            }
                            if ((resp.req_quantity * 1 - tvalue * 1) > 0) {
                                setReqCoverValue((resp.req_quantity * 1 - tvalue * 1).toFixed(2));
                            }
                        });
                    });
                    Common.callApi(Common.apiRight, [sid, 'all', 'APRCHANGEQTY'], function (result1) {
                        setRightAprovQty(JSON.parse(result1));
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function handleReqCoverBank(v, t) {
        setReqCoverBank(v);
        setReqCoverBankName(t);
        // console.log(JSON.stringify(e.target,null,' '))
    }

    function btnBackClick() {
        props.callInProgress();
    }
    function btnDraftClick() {
        saveCover("D");
    }
    function btnFinalClick() {
        if (reqCoverTotValue * 1 === reqQuantity * 1) {
            setShowConfirmBox(true);
            /*if (window.confirm('Are you sure to lock the cover ? Locked cover can not be modified.')) {
                saveCover("F");
            } else {
                saveCover("D");
            }*/
        } else {
            setMsgText("Requested Quantity is not equal to Cover Quantity. It can not be finalized.");
            setMsgBox(true);
        }
    }

    function saveCover(saveMode) {
        setShowConfirmBox(false);
        var object1 = {
            srno: reqSrNo,
            saveMode: saveMode,
            coverDetail: coverListData
        }
        Common.callApi(Common.apiCover, [sid, 'save', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                if (saveMode === "F") {
                    setReqCoverFinal(1);
                }

            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function btnAddCoverClick() {
        if (reqCoverBank === "0" || reqCoverBank === "" || reqCoverRate === "" || reqCoverDeal === "" || parseFloat(reqCoverRate) === 0
            || reqCoverValue === "" || reqCoverValue === "0" || reqCoverValue === 0 || reqCoverValue < 0
        ) {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {

            setCoverListData(Common.arrayAddItem(coverListData, {
                "srno": Common.getRandomString(),
                "bank": reqCoverBank,
                "banknm": reqCoverBankName,
                "cvalue": reqCoverValue,
                "rate": reqCoverRate,
                "deal": reqCoverDeal,
                "vdate": Common.dateDMY(reqCoverValDate)
            }));
            if ((reqQuantity * 1 - reqCoverTotValue * 1 - reqCoverValue * 1).toFixed(2) >= 0) {
                setReqCoverValue((reqQuantity * 1 - reqCoverTotValue * 1 - reqCoverValue * 1).toFixed(2));
            } else {
                setReqCoverValue(0)
            }
            setReqCoverTotValue((reqCoverTotValue * 1 + reqCoverValue * 1).toFixed(2));
            setReqCoverRate("");
            setReqCoverDeal("");
            setRefreshCounter(refreshCounter + 1);
            // console.log(JSON.stringify(coverListData,null,' '));
        }
    }

    function btnDeleteCoverClick(srno, value) {
        if ((reqQuantity * 1 - reqCoverTotValue * 1 + value * 1).toFixed(2) >= 0) {
            setReqCoverValue((reqQuantity * 1 - reqCoverTotValue * 1 + value * 1).toFixed(2));
        } else {
            setReqCoverValue(0)
        }
        setReqCoverTotValue((reqCoverTotValue - value).toFixed(2));
        setCoverListData(Common.arrayRemoveItem(coverListData, "srno", srno));
        setRefreshCounter(refreshCounter + 1);

    }
    function btnRejectClick() {
        var object1 = {
            srno: reqSrNo
        }
        Common.callApi(Common.apiCover, [sid, 'reject', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setReqCoverFinal(1);
                setMsgText(resp.msg);
                setMsgBox(true);

            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }   

    function btnChngQtyClick(flag) {
        var object1 = {
            srno: reqSrNo,
            status: flag
        }
        Common.callApi(Common.apiCover, [sid, 'approvechangeqty', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);
                btnBackClick();
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function handleShowReject() {
        setShowReject(!showReject);
    }

    function btnUnlockCover() {
        var object1 = {
            srno: reqSrNo
        }
        Common.callApi(Common.apiCover, [sid, 'unlockcover', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setMsgText(resp.msg);
                setMsgBox(true);

            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiPaymentApprove, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>In Progress/Cover</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <RequestHeader rhdata={reqData}></RequestHeader>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.req_coveruserid} : {reqData.req_coverusernm}</b>
                        </Col>
                        <Col>
                        </Col>
                    </Row>

                    {
                        (reqCoverFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1)) ?
                            <>
                                <Row>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Bank<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                disabled={coverListData.length !== 0}
                                                value={reqCoverBank}
                                                onChange={(e) => handleReqCoverBank(e.target.value, e.target.options[e.target.selectedIndex].text)}  >
                                                {ddCoverBank.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Cover Quantity<span className="mandatory">*</span> <b>({reqData.req_isd}) ({reqData.req_tenure})</b></Form.Label>
                                            <Form.Control type="text" placeholder="Cover Quantity" maxLength={10} autoComplete="off"
                                                value={reqCoverValue}
                                                onChange={(e) => Common.validateDecValue(e.target.value, setReqCoverValue)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Cover Rate<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Cover Rate" maxLength={10} autoComplete="off"
                                                value={reqCoverRate}
                                                onChange={(e) => Common.validateDecValue(e.target.value, setReqCoverRate)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Deal Number<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Deal Number" maxLength={50} autoComplete="off"
                                                value={reqCoverDeal}
                                                onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setReqCoverDeal)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Expiry Date<span className="mandatory">*</span></Form.Label>
                                            <DatePicker className="form-control"
                                                selected={reqCoverValDate}
                                                onChange={(date) => setReqCoverValDate(date)}
                                                isClearable={coverListData.length === 0}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>&nbsp;</Form.Label><br></br>
                                            <Button variant="outline-primary" size="sm" onClick={(e) => btnAddCoverClick()} >Add</Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </>
                            : null
                    }

                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={
                                (reqCoverTotValue * 1 - reqQuantity * 1) > 0 ? "divDanger" : "divNormal"
                            }
                            >
                                <b>Total Cover : {reqCoverTotValue}</b>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td className='divHide'></td>
                                        <td>Cover Bank</td>
                                        <td>Cover Quantity</td>
                                        <td>Cover Rate</td>
                                        <td>Deal Number</td>
                                        <td>Expiry Date</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {coverListData.map((res) =>
                                        <tr key={res.srno}>
                                            <td>
                                                {
                                                    reqCoverFinal * 1 === 0 ?
                                                        <>
                                                            <div className="colorThemeBlue">
                                                                <span className="handCursor" onClick={(e) => btnDeleteCoverClick(res.srno, res.cvalue)}>
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </span>
                                                            </div>
                                                        </>
                                                        : null
                                                }

                                            </td>
                                            <td className='divHide'>{res.srno}</td>
                                            <td>{res.bank + ' : ' + res.banknm}</td>
                                            <td>{res.cvalue}</td>
                                            <td>{res.rate}</td>
                                            <td>{res.deal}</td>
                                            <td>{(res.vdate).split('-').reverse().join('/')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                            {
                                (reqCoverFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1)) ?
                                    <>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnDraftClick()} >Draft</Button>&nbsp;
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnFinalClick()} >Final</Button>&nbsp;

                                        &nbsp;&nbsp;&nbsp;&nbsp;


                                    </>
                                    : null
                            }
                            {
                                // && reqData.req_bankfilegenrated * 1 === 0
                                (userRight.add * 1 === 1) ?
                                    <>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <input type="checkbox"
                                            checked={showReject}
                                            onChange={handleShowReject}
                                        />&nbsp;&nbsp;&nbsp;&nbsp;
                                        {
                                            showReject ?
                                                <>
                                                    <Button variant="outline-danger" size="sm"
                                                        onClick={(e) => btnRejectClick()}>Reject</Button>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <Button variant="outline-danger" size="sm"
                                                        onClick={(e) => btnUnlockCover()}>Unlock Cover</Button>
                                                </>
                                                : null
                                        }
                                    </>
                                    : null
                            }
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <h5>Quantity Change</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Time Stamp</td>
                                        <td>User</td>
                                        <td>Qty</td>
                                        <td>Status</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {chngQtyListData.map((res) =>
                                        <tr key={res.trc_rndnum}>
                                            <td>{res.trc_time}</td>
                                            <td>{res.um_username}</td>
                                            <td>{res.trc_qty}</td>
                                            <td>{res.trc_status === 'P' ? "Pending" : (res.trc_status === 'C' ? "Cancel" : (res.trc_status === 'R' ? "Rejected" : (res.trc_status === 'A' ? "Approved" : "")))}</td>
                                            {
                                                res.trc_status === 'P' && rightAprovQty.query * 1 === 1 ? <>
                                                    <td><Button variant="outline-success" size="sm" onClick={(e) => btnChngQtyClick('A')} >Approve</Button></td>
                                                    <td><Button variant="outline-danger" size="sm" onClick={(e) => btnChngQtyClick('R')} >Reject</Button></td>
                                                </> : <>
                                                    <td></td><td></td>
                                                </>
                                            }
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>
                            <Form.Group >
                                <Form.Label>Comment</Form.Label>
                                <Form.Control type="text" placeholder="Comment" maxLength={100}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setRemark)}
                                    value={remark} autoComplete="off" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group >
                                <Form.Label>&nbsp;</Form.Label><br></br>
                                <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <TransactionComment srno={props.srno} rc={refreshCounter}></TransactionComment>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showConfirmBox}
                onHide={() => setShowConfirmBox(false)}

                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Cover Final Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Are you sure to lock the cover ? Locked cover can not be modified.
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => saveCover("F")} >Yes</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => saveCover("D")} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default CoverRate;